class Address {
    constructor(address = '', fk_id = '', belongs_to = '', name = '', address_type = '', address1 = '', address2 = '', address3 = '', city = '', state = '', zip = '', country = '', default_type = '', random_id = generateUniqueId(), include_country = true, include_state = true, include_select = false, include_default = false ) {
        this.address_id = address;
        this.fk_id = fk_id;
        this.belongs_to = belongs_to;
        this.name = name;
        this.address_type = address_type;
        this.adress1 = address1;
        this.adress2 = address2;
        this.adress3 = address3;
        this.city = city;
        this.state = state;
        this.zip = zip;
        this.country = country;
        this.address_type = address_type;
        this.default_type = default_type;
        this.random_id = random_id;
        
        this.include_country = include_country;
        this.include_state = include_state;
        this.include_select = include_select;
        this.include_default = include_default; 

        this._debug = {
            // init: true,
            // set_all: true,
            // get_all: true,
            // build_address: true
        }
    }
    
    _methods = { // ----------------------- Start Methods -----------------
        _setters: { // ----------------------- Start - Setters -------------------
            _properties: {
                set_address_id: (id) => this.address_id = id.toString(),
                set_fk_id: (fk_id) => this.fk_id = fk_id.toString(),
                set_belongs_to: (belongs_to) => this.belongs_to = belongs_to.toString(),
                set_name: (name) => this.name = name.toString(),
                set_type: (type) => this.address_type = type.toString(),
                set_address1: (address1) => this.address1 = address1.toString(),
                set_address2: (address2) => this.address2 = address2.toString(),
                set_address3: (address3) => this.address3 = address3.toString(),
                set_city: (city) => this.city = city.toString(),
                set_state: (state) => this.state = state.toString(),
                set_zip: (zip) => this.zip = zip.toString(),
                set_country: (country) => this.country = country.toString(),
                set_address_type: (address_type) => this.address_type = address_type.toString(),
                set_defualt_type: (def) => this.default_type = def.toString(), 
                set_include_default: (bool) => this.include_default = bool,
                set_include_country: (bool) => this.include_country = bool,
                set_include_state: (bool) => this.include_state = bool,
                set_include_select: (bool) => this.include_select = bool,

                set_all_existing_values: (address) => {
                    const setters = this._methods._setters._properties;
                    address.address_id ? setters.set_address_id(address.address_id) : ''; 
                    address.fk_id ? setters.set_fk_id(address.fk_id) : ''; 
                    address.belongs_to ? setters.set_belongs_to(address.belongs_to) : ''; 
                    address.name ? setters.set_name(address.name) : ''; 
                    address.address_type ? setters.set_type(address.address_type) : '';
                    address.address1 ? setters.set_address1(address.address1) : ''; 
                    address.address2 ? setters.set_address2(address.address2) : ''; 
                    address.address3 ? setters.set_address3(address.address3) : ''; 
                    address.city ? setters.set_city(address.city) : ''; 
                    address.state ? setters.set_state(address.state) : ''; 
                    address.zip ? setters.set_zip(address.zip) : ''; 
                    address.country ? setters.set_country(address.country) : ''; 
                    address.address_type ? setters.set_address_type(address.address_type) : ''; 
                    address.default ? setters.set_defualt_type(address.default) : ''; 
                    address.include_country ? setters.set_include_country(address.include_country) : '';
                    address.include_state ? setters.set_include_state(address.include_state) : '';
                    address.include_defualt ? setters.set_include_default(address.include_default) : ''; 
                    address.include_select ? setters.set_include_select(address.include_select) : ''; 
            
                    if(this._debug.set_all)
                        console.log(this, "this - set_all")
                }
            },
            _ui: {
                set_wrapper: () => { am.$(`#address-wrapper-${this.random_id}`).attr('id', `address-wrapper-${this.address_id}`).attr('data-existing-id', this.address_id).attr('data-fk-id', this.fk_id); },
                set_name: () => { am.$(`#address-name-${this.random_id}`).val(this.name).attr('id', `address-name-${this.address_id}`).attr('name', `address[name][${this.address_id}]`); },
                set_type: () => { am.$(`#address-type-${this.random_id}`).val(this.address_type).attr('id', `address-type-${this.address_id}`).attr('name', `address[type][${this.address_id}]`); },
                set_address1: () => { am.$(`#address1-${this.random_id}`).val(this.address1).attr('id', `address1-${this.address_id}`).attr('name', `address[address1][${this.address_id}]`).addClass(`places_address_${this.address_id}`).removeClass(`places_address_${this.random_id}`); },
                set_address2: () => { am.$(`#address2-${this.random_id}`).val(this.address2).attr('id', `address2-${this.address_id}`).attr('name', `address[address2][${this.address_id}]`).addClass(`places_address2_${this.address_id}`).removeClass(`places_address2_${this.random_id}`); },
                set_address3: () => { am.$(`#address3-${this.random_id}`).val(this.address3).attr('id', `address3-${this.address_id}`).attr('name', `address[address3][${this.address_id}]`).addClass(`places_address3_${this.address_id}`).removeClass(`places_address3_${this.random_id}`); },
                set_city: () => { am.$(`#city-${this.random_id}`).val(this.city).attr('id', `city-${this.address_id}`).attr('name', `address[city][${this.address_id}]`).addClass(`places_city_${this.address_id}`).removeClass(`places_city_${this.random_id}`);},
                set_country: () => { 
                    am.$(`#country-${this.random_id}`).val(this.country).attr('id', `country-${this.address_id}`).attr('name', `address[country][${this.address_id}]`).addClass(`places_country_${this.address_id}`).removeClass(`places_country_${this.random_id}`);
                    am.$(`#country-${this.address_id}`).trigger('change');
                },
                set_state: () => {  am.$(`#state-${this.random_id}`).val(this.state).attr('data-state', this.state).attr('id', `state-${this.address_id}`).attr('name', `address[state][${this.address_id}]`).addClass(`places_state_${this.address_id}`).removeClass(`places_state_${this.random_id}`); },
                set_zip: () => { am.$(`#zip-${this.random_id}`).val(this.zip).attr('id', `zip-${this.address_id}`).attr('name', `address[zip][${this.address_id}]`).addClass(`places_zip_${this.address_id}`).removeClass(`places_zip_${this.random_id}`);},

                set_all_existing_values: () => {
                    const setters = this._methods._setters._ui;
                    setters.set_wrapper();
                    setters.set_name(); 
                    setters.set_type();
                    setters.set_address1(); 
                    setters.set_address2(); 
                    setters.set_address3(); 
                    setters.set_city(); 
                    setters.set_state(); 
                    setters.set_zip(); 
                    setters.set_country(); 
                    
                    this._methods._helpers.require_google_places();

                    if(this._debug.set_all)
                        console.log(this, "this - set_all")
                }
            }
        }, // ----------------------- End - Setters -------------------   
        _getters: { // ----------------------- Start - Getters -------------------
            _properties: {
                get_address_id: () => this.address_id.toString(),
                get_fk_id: () => this.fk_id.toString(),
                get_belongs_to: () => this.belongs_to.toString(),
                get_name: () => this.name.toString(),
                get_type: () => this.address_type.toString(),
                get_address1: () => this.address1.toString(),
                get_address2: () => this.address2.toString(),
                get_address3: () => this.address3.toString(),
                get_city: () => this.city.toString(),
                get_state: () => this.state.toString(),
                get_zip: () => this.zip.toString(),
                get_country: () => this.country.toString(),
                get_address_type: () => this.address_type.toString(),
                get_select: () => this.include_select,
                get_default: () => this.default_type,
                get_include_country: () => this.include_country,
                get_include_state: () => this.include_state,
                get_include_defualt: () => this.include_default,
                get_include_select: () => this.include_select,
            
                get_all_existing_values: () => {
                    const getters = this._methods._getters;
                    this.address_id ? getters.get_address_id() : false;
                    this.fk_id ? getters.get_fk_id() : false;
                    // this.belongs_to ? getters.get_belongs_to() : false;
                    this.name ? getters.get_name() : false;
                    this.address_type ? getters.get_type() : false;
                    this.address1 ? getters.get_address1() : false;
                    this.address2 ? getters.get_address2() : false;
                    this.address3 ? getters.get_address3() : false;
                    this.city ? getters.get_city() : false;
                    this.state ? getters.get_state() : false;
                    this.zip ? getters.get_zip() : false;
                    this.country ? getters.get_country() : false;
                    this.address_type ? getters.get_address_type() : false;
                    this.default_type ? getters.get_default() : false;
                    this.include_country ? getters.get_include_country() : true;
                    this.include_state ? getters.get_include_state() : true;
                    this.include_default ? getters.get_include_defualt() : false;
                    this.include_select ? getters.get_include_select() : false;
            
                    if(this._debug.get_all)
                        console.log(this, "this - get_all")
                }
            },
            _ui: {
                get_address_id: ($address_section) => { return $address_section.attr('data-existing-id') ? $address_section.attr('data-existing-id') : 0 }, 
                get_is_dirty_address: ($address_section) => { return $address_section.attr('data-dirty-address') ? $address_section.attr('data-dirty-address') : 0 }, 
                get_fk_id: ($address_section) => { return $address_section.attr('data-fk-id') }, 
                get_address_type: ($address_section) => { return $address_section.find('.js-address-type').val() }, 
                get_name: ($address_section) => { return $address_section.find('.js-address-name').val() }, 
                get_address1: ($address_section) => { return $address_section.find('.js-address').val() }, 
                get_address2: ($address_section) => { return $address_section.find('.js-address2').val() }, 
                get_address3: ($address_section) => { return $address_section.find('.js-address3').val() }, 
                get_city: ($address_section) => { return $address_section.find('.js-address-city').val() }, 
                get_country: ($address_section) => { return $address_section.find('.js-address-country').val() }, 
                get_state: ($address_section) => { return $address_section.find('.js-address-state').val() }, 
                get_zip: ($address_section) => { return $address_section.find('.js-address-zip').val() }, 
                // get_belongs_to: ($address_section) => { return $address_section.find('')}, 
                // get_default: ($address_section) => { return $address_section.find('')}, 
            
                get_all_values: ($address_section) => {
                    const getters = this._methods._getters._ui;
                    var values = {
                        address_id: getters.get_address_id($address_section),
                        is_dirty: getters.get_is_dirty_address($address_section),
                        fk_id: getters.get_fk_id($address_section),
                        name: getters.get_name($address_section),
                        address_type: getters.get_address_type($address_section),
                        address1: getters.get_address1($address_section),
                        address2: getters.get_address2($address_section),
                        address3: getters.get_address3($address_section),
                        city: getters.get_city($address_section),
                        country: getters.get_country($address_section),
                        state: getters.get_state($address_section),
                        zip: getters.get_zip($address_section)
                    }
                    // getters.get_belongs_to($address_section);
                    // getters.get_default($address_section);
            
                    if(this._debug.get_all)
                        console.log(this, "this - get_all")

                    return values;
                }
            }
        }, // ----------------------- End - Getters -------------------
        _builders: { // ----------------------- Start - Builders -------------------
            // ----------------------- Start - build_address -------------------
            build_address: () => {
                if(this._debug.build_address)
                    console.log(this, "this - build_address");

                const id = this.address_id == '' ? this.random_id : this.address_id;

                const country = new CountrySelect();
                const country_dropdown = country._methods._builders.build_country_select_html(id);

                const state = new StateSelect();
                const state_dropdown = state._methods._builders.build_state_select_html(id);

                let address = am.$(`
                    <div id="address-wrapper-${id}" class="address-section" data-existing-id="" data-fk-id="">
                        <div class="am-section-row address-name">
                            <label class="am-section-label" id="address-name-label" for="address-name-${id}">${get_language_translation('LANG_LABEL_ADDRESS_NAME')}</label>
                            <input id="address-name-${id}" type="text" class="am-section-input js-address-name" name="address[name][${id}]" value/>
                        </div>

                        <input type="hidden" id="address-type-${id}" type="text" class="am-section-input js-address-type" name="address[type][${id}]" value="billing"/>
                        
                        <div class="am-section-row address1">
                            <label class="am-section-label" id="address-label" for="address1-${id}">${get_language_translation('LANG_LABEL_ADDRESS')}</label>
                            <input id="address1-${id}" type="text" class="am-section-input js-required js-address places_address places_address_${id}" name="address[address1][${id}]" onchange="getid(this)" onKeyPress="checkenterkey(event, this)" value/>
                        </div>
                        <div class="am-section-row address2">
                            <label class="am-section-label" id="address2-label" for="address2-${id}">${get_language_translation('LANG_LABEL_ADDRESS_2')}</label>
                            <input id="address2-${id}" type="text" class="am-section-input js-address2 places_address2_${id}" name="address[address2][${id}]"  value/>
                        </div>
                        <div class="am-section-row address3">
                            <label class="am-section-label" id="address3-label" for="address3-${id}">${get_language_translation('LANG_LABEL_ADDRESS_3')}</label>
                            <input id="address3-${id}" type="text" class="am-section-input js-address3 am-col2 places_address3_${id}" name="address[address3][${id}]"  value/>
                        </div>
                        <div class="am-section-row address-city">
                            <label class="am-section-label" id="city-label" for="city-${id}">${get_language_translation('LANG_LABEL_CITY')}</label>
                            <input id="city-${id}" type="text" class="am-section-input js-required js-address-city places_city_${id}" name="address[city][${id}]" value />
                        </div>

                        ${ this.include_country ? country_dropdown : '' }

                        ${ this.include_country ? state_dropdown : '' }

                        <div class="am-section-row address-zip">
                            <label class="am-section-label" for="zip-${id}">${get_language_translation('LANG_LABEL_ZIP')}</label>
                            <input id="zip-${id}" type="text" class="am-section-input js-required js-address-zip am-col2 places_zip_${id}" name="address[zip][${id}]"  minlength="5" maxlength="10" data-not_required="false" value/>
                        </div>
                    </div>
                `);

                if(this.include_country)
                    country._methods._helpers.country_get_ajax(id);

                return address;
            },
            // ----------------------- End - build_address ------------------- 
        }, // ----------------------- End - Builders -------------------
        _helpers: { // ----------------------- Start - _Helpers -------------------
            check_for_default_billing_address: async (address_lookup_type) =>{
                const Address = this;
                await am.$.ajax({
                    url: `ajax/contacts/default_billing_address_exists/${address_lookup_type}`,
                    type: 'GET',
                    success: function (data) { 
                        if(data){
                            Address._methods._setters._properties.set_all_existing_values(data);
                            Address._methods._setters._ui.set_all_existing_values();
                        }

                        Address._methods._helpers.require_google_places();
                    },
                    error: function (e){ console.log(e); }
                })
            },
            listen_to_address_inputs: ($address) => {
                var inputs = $address.find('input, select').not('[type="hidden"]');
                inputs.on('keyup', () => { 
                    $address.attr('data-dirty-address', 1); 
                })
            },
            require_google_places: () => {
                googleplaces();
            }
        }, // ----------------------- End - _Helpers -------------------
    } // ----------------------- End Std Methods -----------------
} 